import { render, staticRenderFns } from "./Tippy.vue?vue&type=template&id=48996429&scoped=true&"
import script from "./Tippy.vue?vue&type=script&lang=js&"
export * from "./Tippy.vue?vue&type=script&lang=js&"
import style0 from "./Tippy.vue?vue&type=style&index=0&id=48996429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48996429",
  null
  
)

export default component.exports